import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 获取Record列表
export const getRecordList = (params) => { return req("get", "/api/getErrorRecordList", params) };



// WEBPACK FOOTER //
// ./src/api/errorMG.js